// ./src/pages/setup/components/services/customerService.js

import API_BASE_URL from "../../../../../Constants";

export const fetchCustomers = async (
  page,
  size,
  query,
  sortField,
  sortOrder
) => {
  const queryString = query ? `&q=${encodeURIComponent(query)}` : "";
  const sortString =
    sortField && sortOrder
      ? `&sortField=${encodeURIComponent(
          sortField
        )}&sortOrder=${encodeURIComponent(sortOrder)}`
      : "";
  try {
    const response = await fetch(
      `${API_BASE_URL}/api/setup/customers?page=${
        page - 1
      }&size=${size}${queryString}${sortString}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
      }
    );
    if (!response.ok) {
      throw new Error(`Error: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Failed to fetch customers:", error);
    throw error;
  }
};

export const fetchAllCustomers = async () => {
  const response = await fetch(`${API_BASE_URL}/api/setup/customers/all`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  });
  if (!response.ok) {
    throw new Error(`Error: ${response.status}`);
  }
  return response.json();
};

export const editCustomer = async (customerId, data) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/api/setup/customers/${customerId}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify(data),
      }
    );

    if (!response.ok) {
      throw new Error(`Error: ${response.status}`);
    }

    const responseData = await response.json();
    console.log("response: ", responseData);
    return responseData;
  } catch (error) {
    console.error("Failed to edit customer:", error);
    throw error;
  }
};

export const deleteCustomer = async (customerId) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/api/setup/customers/${customerId}`,
      {
        method: "DELETE",
        credentials: "include",
      }
    );

    if (!response.ok) {
      throw new Error(await response.text());
    }
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateCustomerContacts = async (customerId, data) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/api/setup/customer-contact-intersections/update/${customerId}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify(data),
      }
    );

    if (!response.ok) {
      throw new Error(`Error: ${response.status}`);
    }
  } catch (error) {
    console.error("Failed to update customer contacts:", error);
    throw error;
  }
};

export const createCustomer = async (data) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/setup/customers/create`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      throw new Error(`Error: ${response.status}`);
    }

    const responseData = await response.json();
    console.log("response: ", responseData);
    return responseData;
  } catch (error) {
    console.error("Failed to create customer:", error);
    throw error;
  }
};

export const updateCustomerBuildings = async (data) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/api/setup/buildings/update-all`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify(data),
      }
    );

    if (!response.ok) {
      throw new Error(`Error: ${response.status}`);
    }
  } catch (error) {
    console.error("Failed to update customer buildings:", error);
    throw error;
  }
};

export const createBuilding = async (data) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/setup/buildings`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      throw new Error(`Error: ${response.status}`);
    }

    const responseData = await response.json();
    console.log("response: ", responseData);
    return responseData;
  } catch (error) {
    console.error("Failed to create building:", error);
    throw error;
  }
};
